import { render, staticRenderFns } from "./ConfirmBackorderModal.vue?vue&type=template&id=a6a63bd4&scoped=true&"
import script from "./ConfirmBackorderModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmBackorderModal.vue?vue&type=script&lang=js&"
import style0 from "@/../public/css/shoppingpr.css?vue&type=style&index=0&id=a6a63bd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a63bd4",
  null
  
)

export default component.exports